import { render, staticRenderFns } from "./CompaniesUser.vue?vue&type=template&id=75ca1500"
import script from "./CompaniesUser.vue?vue&type=script&lang=js"
export * from "./CompaniesUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports